module.exports = "<div class=\"col-12\">\n  <div class=\"alert alert-warning\">\n    <h3>Página Não encontrada.</h3>\n  </div>\n</div>"